import { render, staticRenderFns } from "./Referencia.vue?vue&type=template&id=64b5e193&scoped=true"
import script from "./Referencia.vue?vue&type=script&lang=ts"
export * from "./Referencia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5e193",
  null
  
)

export default component.exports